import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-calculator-item',
    templateUrl: './calculator-item.component.html',
    styleUrls: ['./calculator-item.component.css']
})
export class CalculatorItemComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/calculator-item.component.ts